export default __webpack_public_path__ + "static/media/about1.a6cd80bc.jpeg";